import { useFlags } from "launchdarkly-react-client-sdk";

import { FeatureFlag } from "../constants";

const FEATURE_FLAG_DEFAULTS = {
  [FeatureFlag.FireboltAppEnableContactSupportFormLoggedIn]: true,
};

export const useAllFlags = () => {
  const flags = useFlags<Partial<FlagsInterface>>();
  return {
    ...FEATURE_FLAG_DEFAULTS,
    ...flags,
  };
};

export interface FlagsInterface {
  [FeatureFlag.FireboltAppReadOnlyMaintenanceMode]: boolean | undefined;
  [FeatureFlag.FireboltAppFullMaintenanceMode]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableContactSupportFormLoggedIn]:
    | boolean
    | undefined;
  [FeatureFlag.ServiceIdentityBillingEnableRegisterWithCredits]:
    | boolean
    | undefined;
  [FeatureFlag.FireboltAppEnableQueryProfile]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableEngineObservAndQueryHistory]:
    | boolean
    | undefined;
  [FeatureFlag.FireboltAppEnableEngineClusterProperty]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableBillingV3]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableEditions]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableIngestionWizard]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableRoleWizard]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableLargeInstanceTypes]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableXsInstanceType]: boolean | undefined;
  [FeatureFlag.FireboltAppShowRolesPage]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableRegistrationPage]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableReadCsvNewParams]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableDemoTool]: boolean | undefined;
  [FeatureFlag.FireboltAppCollectSignupFirstStep]: boolean | undefined;
  [FeatureFlag.FireboltAppEnablePrivateLink]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableBillingPaymentMethods]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableWireTransfer]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableACH]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableGcpPayment]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableCreditCardPayments]: boolean | undefined;
  [FeatureFlag.AccountDbInformationSchemaViews]:
    | {
        views: {
          name: string;
          columns: { columnName: string; dataType: string }[];
        }[];
      }
    | undefined;
  [FeatureFlag.FireboltAppEnableUiOwnership]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableOrbac]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableOrbacPage]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableProactiveWarnings]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableServiceAccounts]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableChatBot]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableTransactions]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableQueryCacheRatio]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableHistoryExplain]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableTimelineExplain]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableFlamegraphExplain]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableRemainingCredits]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableAiInEditor]: boolean | undefined;
  [FeatureFlag.FireboltAppCreditsValue]: number | undefined;
  [FeatureFlag.FireboltAppEnableDatabasesPrivilegesInEdit]: boolean | undefined;
  [FeatureFlag.FireboltAppEngineDefaultValuesOnCreate]: object | undefined;
  [FeatureFlag.FireboltAppDatabasesLimitForPrivilegesLoad]: number | undefined;
  [FeatureFlag.FireboltAppEnableGcpAccount]: boolean | undefined;
  [FeatureFlag.FireboltAppEnableGcpFakeSystemEngine]: string | undefined;
  [FeatureFlag.FireboltAppEnableConnectWizard]: boolean | undefined;
  [FeatureFlag.FawkesDisableRegistration]: boolean | undefined;
}
